<template>
  <div>
    <a-tabs :default-active-key="1" @change="callback">
      <a-tab-pane v-for="(item,index) in atabs" :key="index+1" :tab="item.name"></a-tab-pane>
    </a-tabs>
    <a-row :gutter="30">
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">姓名</a-col>
          <a-col span="18">
            <a-input
                style="display: block"
                placeholder="请输入姓名"
                v-model="params.name"
            ></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">电话号码</a-col>
          <a-col span="18">
            <a-input
                style="display: block"
                placeholder="请输入手机号码"
                v-model="params.num"
            ></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8">
        <a-button
            type="primary"
            style="margin-right: 12px; padding: 0 30px"
            @click="getFilterData()"
        >筛选
        </a-button
        >
        <a-button style="margin-right: 12px" @click="resetParams"
        >重置
        </a-button
        >
      </a-col>
    </a-row>
    <a-row>
      <a-col span="18">
        <time-bar ref="timeTeam" :clean="clean" @change="onChangetime" @timeclean="timeclean"></time-bar>
      </a-col>
      <a-col span="2" style="text-align: center">
        <a-button type="primary" @click="getexport">
          导出数据
        </a-button>
      </a-col>
    </a-row>
    <a-table v-if="tabkey!=2"
             style="margin-top: 20px"
             rowKey="uid"
             :loading="loading"
             :pagination="pagination"
             :columns="columns"
             :data-source="dataSource"
             @change="getData">
      <template v-if="tabkey==1">
        <span slot="customTitle">新增职位数 <a-tooltip placement="topRight">
        <template slot="title">
          <span>说明：统计老客户新增职位数及IE自己开发客户的新增职位数</span>
        </template>
        <a-icon type="question-circle"/>
      </a-tooltip></span>
      </template>
      <template slot="role_id" slot-scope="status, record">
        <span>{{
            record.role_id == 12 ? 'BD' :
                record.role_id == 13 ? '地推' :
                    record.role_id == 14 ? 'IE' : 'BD+IE'
          }}</span>
      </template>
      <template slot="AUDIT_PASSED" slot-scope="status, record">
        <span>{{ record.post_counts.AUDIT_PASSED ? record.post_counts.AUDIT_PASSED : 0 }}</span>
      </template>
      <template slot="CREATED" slot-scope="status, record">
        <span>{{ record.post_counts.CREATED ? record.post_counts.CREATED : 0 }}</span>
      </template>
      <template slot="INTERVIEW" slot-scope="status, record">
        <span>{{ record.post_counts.INTERVIEW ? record.post_counts.INTERVIEW : 0 }}</span>
      </template>
      <template slot="OFFERED" slot-scope="status, record">
        <span>{{ record.post_counts.OFFERED ? record.post_counts.OFFERED : 0 }}</span>
      </template>
      <template slot="ENTERED" slot-scope="status, record">
        <span>{{ record.post_counts.ENTERED ? record.post_counts.ENTERED : 0 }}</span>
      </template>
    </a-table>
    <a-tabs v-if="tabkey==2" type="card" @change="callback_in" style="margin-top: 20px">
      <a-tab-pane key="1" tab="开发数据">
        <a-table
            rowKey="uid"
            :loading="loading_kf"
            :pagination="pagination_kf"
            :columns="columns_kf"
            :data-source="dataSource_kf"
            @change="getData_kf">
          <template slot="role_id" slot-scope="status, record">
        <span>{{
            record.role_id == 12 ? 'BD' :
                record.role_id == 13 ? '地推' :
                    record.role_id == 14 ? 'IE' : 'BD+IE'
          }}</span>
          </template>
        </a-table>
      </a-tab-pane>
      <a-tab-pane key="2" tab="做单数据">
        <a-table
            rowKey="uid"
            :loading="loading_zd"
            :pagination="pagination_zd"
            :columns="columns_zd"
            :data-source="dataSource_zd"
            @change="getData_zd">
          <template slot="role_id" slot-scope="status, record">
        <span>{{
            record.role_id == 12 ? 'BD' :
                record.role_id == 13 ? '地推' :
                    record.role_id == 14 ? 'IE' : 'BD+IE'
          }}</span>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import Api from "@/api";
import TimeBar from "@/components/time-bar.component";


export default {
  name: "index",
  components: {TimeBar},
  data() {
    return {
      baseURL: process.env.VUE_APP_BASEURL,
      dataSource: [],
      dataSource_kf: [],
      dataSource_zd: [],
      columns: [
        {
          title: '姓名',
          dataIndex: 'name',
          key: 'name',
          align: 'center'
        },
        {
          title: '电话',
          dataIndex: 'tel',
          key: 'tel',
          align: 'center',
          width: 120
        },
        {
          title: '角色',
          dataIndex: 'role_id',
          scopedSlots: {customRender: 'role_id'},
          key: 'role_id',
          align: 'center',
          width: 110
        },
        {
          title: 'IE审核通过推荐给客户',
          scopedSlots: {customRender: 'AUDIT_PASSED'},
          key: 'AUDIT_PASSED',
          align: 'center'
        },
        {
          title: '一面数',
          scopedSlots: {customRender: 'INTERVIEW'},
          key: 'INTERVIEW',
          align: 'center'
        },
        {
          title: 'Offer数',
          scopedSlots: {customRender: 'OFFERED'},
          key: 'OFFERED',
          align: 'center'
        },
        {
          title: '入职数',
          scopedSlots: {customRender: 'ENTERED'},
          key: 'ENTERED',
          align: 'center'
        },
        {
          title: '开票金额(元)',
          dataIndex: 'invoice_total',
          key: 'invoice_total',
          align: 'center'
        },
        {
          title: '回款金额(元)',
          dataIndex: 'payment_total',
          key: 'payment_total',
          align: 'center'
        },
        {
          title: '新增HR数',
          dataIndex: 'hr_count',
          key: 'hr_count',
          align: 'center'
        },
        {
          dataIndex: 'job_count',
          key: 'job_count',
          align: 'center',
          slots: {title: 'customTitle'},
        },
        // {
        //   title: 'Tags',
        //   key: 'tags',
        //   dataIndex: 'tags',
        //   scopedSlots: { customRender: 'tags' },
        // },
        // {
        //   title: 'Action',
        //   key: 'action',
        //   scopedSlots: { customRender: 'action' },
        // },
      ],
      columns_kf: [
        {
          title: '姓名',
          dataIndex: 'name',
          key: 'name',
          align: 'center'
        },
        {
          title: '电话',
          dataIndex: 'tel',
          key: 'tel',
          align: 'center',
          width: 110
        },
        {
          title: '角色',
          scopedSlots: {customRender: 'role_id'},
          key: 'role_id',
          align: 'center',
          width: 110
        },
        {
          title: '系统标记数',
          dataIndex: 'system_mark_count',
          key: 'system_mark_count',
          align: 'center'
        },
        {
          title: '激活已注册未签约数',
          dataIndex: 'active_reg_un_sign_count',
          key: 'active_reg_un_sign_count',
          align: 'center'
        },
        {
          title: '激活已注册已签约但最近一个月0推荐',
          dataIndex: 'active_reg_sign_zero_post_count',
          key: 'active_reg_sign_zero_post_count',
          align: 'center'
        },
        {
          title: '激活已注册未签约的推荐数',
          dataIndex: 'active_reg_un_sign_post_count',
          key: 'active_reg_un_sign_post_count',
          align: 'center'
        },
        {
          title: '激活已注册已签约的推荐数',
          dataIndex: 'active_reg_sign_post_count',
          key: 'active_reg_sign_post_count',
          align: 'center'
        },
        {
          title: '开发新注册签约猎头数',
          dataIndex: 'active_reg_sign_hunter_count',
          key: 'active_reg_sign_hunter_count',
          align: 'center'
        },
        {
          title: '开发新注册签约猎企数',
          dataIndex: 'active_reg_sign_hunter_company_count',
          key: 'active_reg_sign_hunter_company_count',
          align: 'center'
        }
      ],
      columns_zd: [
        {
          title: '姓名',
          dataIndex: 'name',
          key: 'name',
          align: 'center'
        },
        {
          title: '电话',
          dataIndex: 'tel',
          key: 'tel',
          align: 'center',
          width: 110
        },
        {
          title: '角色',
          scopedSlots: {customRender: 'role_id'},
          key: 'role_id',
          align: 'center',
          width: 110
        },
        {
          title: '新开发猎头推荐数',
          dataIndex: 'new_hunter_post_count',
          key: 'new_hunter_post_count',
          align: 'center'
        },
        {
          title: '新开发猎企推荐数',
          dataIndex: 'new_hunter_company_post_count',
          key: 'new_hunter_company_post_count',
          align: 'center'
        },
        {
          title: '名下猎头Offer数',
          dataIndex: 'pm_hunter_offer_count',
          key: 'pm_hunter_offer_count',
          align: 'center'
        },
        {
          title: '名下猎头Offer金额(元)',
          dataIndex: 'pm_hunter_offer_salary_total',
          key: 'pm_hunter_offer_salary_total',
          align: 'center'
        },
        {
          title: '名下猎企Offer数',
          dataIndex: 'pm_hunter_company_offer_count',
          key: 'pm_hunter_company_offer_count',
          align: 'center'
        },
        {
          title: '名下猎企Offer金额(元)',
          dataIndex: 'pm_hunter_company_offer_salary_total',
          key: 'pm_hunter_company_offer_salary_total',
          align: 'center'
        },
        {
          title: '名下猎头开票金额(元)',
          dataIndex: 'pm_hunter_income_amount',
          key: 'pm_hunter_income_amount',
          align: 'center'
        },
        {
          title: '名下猎企开票金额(元)',
          dataIndex: 'pm_hunter_company_income_amount',
          key: 'pm_hunter_company_income_amount',
          align: 'center'
        }
      ],
      atabs: [
        {
          name: "IE数据"
        },
        {
          name: "地推数据"
        },
        {
          name: "BD数据"
        }
      ],
      params: {
        name: "",
        num: "",
        time: ""
      },
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: (total) => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true,
      },
      pagination_kf: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: (total) => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true,
      },
      pagination_zd: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: (total) => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true,
      },
      loading: false,
      loading_kf: false,
      loading_zd: false,
      clean: false,
      tabkey: '1',
      tabkey_in: '1'
    };
  },
  mounted() {
    this.getData()
  },
  watch: {
    tabkey() {
      let params = {};
      this.params = params;
      this.clean = true;
      this.pagination.current = 1;
      if (this.tabkey == 1) {
        this.columns = [
          {
            title: '姓名',
            dataIndex: 'name',
            key: 'name',
            align: 'center'
          },
          {
            title: '电话',
            dataIndex: 'tel',
            key: 'tel',
            align: 'center',
            width: 110
          },
          {
            title: '角色',
            scopedSlots: {customRender: 'role_id'},
            key: 'role_id',
            align: 'center',
            width: 110
          },
          {
            title: 'IE审核通过推荐给客户',
            scopedSlots: {customRender: 'CREATED'},
            key: 'CREATED',
            align: 'center'
          },
          {
            title: '一面数',
            scopedSlots: {customRender: 'INTERVIEW'},
            key: 'INTERVIEW',
            align: 'center'
          },
          {
            title: 'Offer数',
            scopedSlots: {customRender: 'OFFERED'},
            key: 'OFFERED',
            align: 'center'
          },
          {
            title: '入职数',
            scopedSlots: {customRender: 'ENTERED'},
            key: 'ENTERED',
            align: 'center'
          },
          {
            title: '开票金额(元)',
            dataIndex: 'invoice_total',
            key: 'invoice_total',
            align: 'center'
          },
          {
            title: '回款金额(元)',
            dataIndex: 'payment_total',
            key: 'payment_total',
            align: 'center'
          },
          {
            title: '新增HR数',
            dataIndex: 'hr_count',
            key: 'hr_count',
            align: 'center'
          },
          {
            dataIndex: 'job_count',
            key: 'job_count',
            align: 'center',
            slots: {title: 'customTitle'},
          }
        ];
        this.getData()
      }
      if (this.tabkey == 2) {
        this.getData_kf();
        this.getData_zd();
      }
      if (this.tabkey == 3) {
        this.columns = [
          {
            title: '姓名',
            dataIndex: 'name',
            key: 'name',
            align: 'center'
          },
          {
            title: '电话',
            dataIndex: 'tel',
            key: 'tel',
            align: 'center',
            width: 110
          },
          {
            title: '角色',
            scopedSlots: {customRender: 'role_id'},
            key: 'role_id',
            align: 'center',
            width: 110
          },
          {
            title: '激活客户',
            dataIndex: 'bd_active_company_count',
            key: 'bd_active_company_count',
            align: 'center'
          },
          {
            title: '有效开发客户',
            dataIndex: 'bd_dev_company_count',
            key: 'bd_dev_company_count',
            align: 'center'
          },
          {
            title: 'Offer个数',
            dataIndex: 'bd_offer_count',
            key: 'bd_offer_count',
            align: 'center'
          },
          {
            title: 'Offer金额(元)',
            dataIndex: 'bd_offer_salary_total',
            key: 'bd_offer_salary_total',
            align: 'center'
          },
          {
            title: '开票金额(元)',
            dataIndex: 'post_income_payment_count',
            key: 'post_income_payment_count',
            align: 'center'
          },
          {
            title: '回款金额(元)',
            dataIndex: 'post_income_invoice_count',
            key: 'post_income_invoice_count',
            align: 'center'
          },
        ]
        this.getDataBD()
      }
    },
  },
  methods: {
    timeclean(){
      this.clean = false;
    },
    onChangetime(a) {
      console.log(a.value)
      this.params.timestring = a.value
      if (this.tabkey == 1) {
        this.getData(this.pagination);
      }
      if (this.tabkey == 2) {
        this.getData_kf(this.pagination_kf);
        this.getData_zd(this.pagination_zd);
      }
      if (this.tabkey == 3) {
        this.getDataBD(this.pagination)
      }
    },
    callback(key) {
      this.tabkey = key
      console.log(key);
    },
    getexport() {
      if (this.tabkey == 1) {
        const downloadElement = document.createElement("a"); // 创建一个标签
        const href =
            this.baseURL +
            "/kip/exportIeData?time_start=" + (this.params.timestring ? this.params.timestring[0] : '') +
            "&time_end=" + (this.params.timestring ? this.params.timestring[1] : '') +
            "&ie_user_name=" + (this.params.name?this.params.name:'') +
            "&ie_user_tel=" + (this.params.num?this.params.num:'')
        console.log(href)
        downloadElement.style.display = "none";
        downloadElement.href = href;
        // downloadElement.download = 'export' + getdate() + ".csv";  // 下载之后文档的名字
        document.body.appendChild(downloadElement); //把a标签加入body中
        downloadElement.click();
        document.body.removeChild(downloadElement); // 点击之后移除a标签
        window.URL.revokeObjectURL(href); // 移除url
      }
      if (this.tabkey == 2) {
        if (this.tabkey_in == 1) {
          const downloadElement = document.createElement("a"); // 创建一个标签
          const href =
              this.baseURL +
              "/kip/exportLandDevData?time_start=" + (this.params.timestring ? this.params.timestring[0] : '') +
              "&time_end=" + (this.params.timestring ? this.params.timestring[1] : '') +
              "&ie_user_name=" + (this.params.name?this.params.name:'') +
              "&ie_user_tel=" + (this.params.num?this.params.num:'')
          console.log(href)
          downloadElement.style.display = "none";
          downloadElement.href = href;
          // downloadElement.download = 'export' + getdate() + ".csv";  // 下载之后文档的名字
          document.body.appendChild(downloadElement); //把a标签加入body中
          downloadElement.click();
          document.body.removeChild(downloadElement); // 点击之后移除a标签
          window.URL.revokeObjectURL(href); // 移除url
        }
        if (this.tabkey_in == 2) {
          const downloadElement = document.createElement("a"); // 创建一个标签
          const href =
              this.baseURL +
              "/kip/exportLandPostData?time_start=" + (this.params.timestring ? this.params.timestring[0] : '') +
              "&time_end=" + (this.params.timestring ? this.params.timestring[1] : '') +
              "&ie_user_name=" + (this.params.name?this.params.name:'') +
              "&ie_user_tel=" + (this.params.num?this.params.num:'')
          console.log(href)
          downloadElement.style.display = "none";
          downloadElement.href = href;
          // downloadElement.download = 'export' + getdate() + ".csv";  // 下载之后文档的名字
          document.body.appendChild(downloadElement); //把a标签加入body中
          downloadElement.click();
          document.body.removeChild(downloadElement); // 点击之后移除a标签
          window.URL.revokeObjectURL(href); // 移除url
        }
      }
      if (this.tabkey == 3) {
        const downloadElement = document.createElement("a"); // 创建一个标签
        const href =
            this.baseURL +
            "/kip/exportBdData?time_start=" + (this.params.timestring ? this.params.timestring[0] : '') +
            "&time_end=" + (this.params.timestring ? this.params.timestring[1] : '') +
            "&ie_user_name=" + (this.params.name?this.params.name:'') +
            "&ie_user_tel=" + (this.params.num?this.params.num:'')
        console.log(href)
        downloadElement.style.display = "none";
        downloadElement.href = href;
        // downloadElement.download = 'export' + getdate() + ".csv";  // 下载之后文档的名字
        document.body.appendChild(downloadElement); //把a标签加入body中
        downloadElement.click();
        document.body.removeChild(downloadElement); // 点击之后移除a标签
        window.URL.revokeObjectURL(href); // 移除url
      }

    },
    getFilterData() {
      this.pagination.current = 1;
      this.pagination_kf.current = 1;
      this.pagination_zd.current = 1;
      if (this.tabkey == 1) {
        this.getData(this.pagination);
      }
      if (this.tabkey == 2) {
        this.getData_kf();
        this.getData_zd();
      }
      if (this.tabkey == 3) {
        this.getDataBD()
      }
    },
    async getData_kf(pagination) {
      this.loading_kf = true;
      if (pagination) {
        let pager = {...this.pagination};
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination_kf = pager;
      } else {
        this.pagination_kf.current = 1;
      }
      let params = {
        time_start: this.params.timestring ? this.params.timestring[0] : null,
        time_end: this.params.timestring ? this.params.timestring[1] : null,
        ie_user_name: this.params.name,
        ie_user_tel: this.params.num,
        page: this.pagination_kf.current,
        limit: this.pagination_kf.pageSize,
      };
      try {
        let response = await Api.hunter.kpigetLandDevData(params);
        this.pagination_kf.total = +response.total;
        this.dataSource_kf = response.list;
        this.loading_kf = false;
      } catch (e) {
      }
    },
    async getData_zd(pagination) {
      this.loading_zd = true;
      if (pagination) {
        let pager = {...this.pagination};
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination_zd = pager;
      } else {
        this.pagination_zd.current = 1;
      }
      let params = {
        time_start: this.params.timestring ? this.params.timestring[0] : null,
        time_end: this.params.timestring ? this.params.timestring[1] : null,
        ie_user_name: this.params.name,
        ie_user_tel: this.params.num,
        page: this.pagination_zd.current,
        limit: this.pagination_zd.pageSize,
      };
      try {
        let response = await Api.hunter.kpigetLandPostData(params);
        this.pagination_zd.total = +response.total;
        this.dataSource_zd = response.list;
        this.loading_zd = false;
      } catch (e) {
      }
    },
    async getData(pagination) {
		if(this.tabkey==1){
			this.loading = true;
			if (pagination) {
			  let pager = {...this.pagination};
			  pager.current = pagination.current;
			  pager.pageSize = pagination.pageSize;
			  this.pagination = pager;
			} else {
			  this.pagination.current = 1;
			}
			let params = {
			  time_start: this.params.timestring ? this.params.timestring[0] : null,
			  time_end: this.params.timestring ? this.params.timestring[1] : null,
			  ie_user_name: this.params.name,
			  ie_user_tel: this.params.num,
			  page: this.pagination.current,
			  limit: this.pagination.pageSize,
			};
			try {
			  let response = await Api.hunter.kpigetIeData(params);
			  this.pagination.total = +response.total;
			  this.dataSource = response.list;
			  this.loading = false;
			} catch (e) {
			}
		}else if(this.tabkey==3){
			this.getDataBD()
		}
    },
    async getDataBD(pagination) {
      this.loading = true;
      if (pagination) {
        let pager = {...this.pagination};
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      } else {
        this.pagination.current = 1;
      }
      let params = {
        time_start: this.params.timestring ? this.params.timestring[0] : null,
        time_end: this.params.timestring ? this.params.timestring[1] : null,
        ie_user_name: this.params.name,
        ie_user_tel: this.params.num,
        page: this.pagination.current,
        limit: this.pagination.pageSize,
      };
      try {
        let response = await Api.hunter.kpigetBdData(params);
        this.pagination.total = +response.total;
        this.dataSource = response.list;
        this.loading = false;
      } catch (e) {
      }
    },
    callback_in(key) {
      this.tabkey_in = key;
    },
    resetParams() {
      let params = {};
      this.params = params;
      this.clean = true;
      if(this.tabkey==1){
        this.getData();
      }else if(this.tabkey==2){
        this.getData_kf();
        this.getData_zd();
      }else if(this.tabkey==3){
        this.getDataBD();
      }
    },
  },
}
</script>

<style scoped>

</style>
